import { useLang } from "@/lib/i18n";

export const LangSwitch = ({ testid = "lang-switch", className = "" }) => {
  const { lang, setLang } = useLang();
  return (
    <div role="group" aria-label="Språk / Language" data-testid={testid}
      className={`flex items-center border border-white/15 font-mono text-xs font-bold uppercase tracking-widest ${className}`}>
      {["no", "en"].map((l) => (
        <button key={l} type="button" onClick={() => setLang(l)} aria-pressed={lang === l} data-testid={`${testid}-${l}`}
          className={`px-2.5 py-2.5 transition-colors ${lang === l ? "bg-white text-[#08090b]" : "text-zinc-300 hover:text-white"}`}>
          {l}
        </button>
      ))}
    </div>
  );
};
